import { render, staticRenderFns } from "./privateGoodsPublish.vue?vue&type=template&id=cc5160b2&scoped=true"
import script from "./privateGoodsPublish.vue?vue&type=script&lang=js"
export * from "./privateGoodsPublish.vue?vue&type=script&lang=js"
import style0 from "./privateGoodsPublish.vue?vue&type=style&index=0&id=cc5160b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc5160b2",
  null
  
)

export default component.exports